import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "_pos-r" }
const _hoisted_2 = { class: "gfu-card__media-wrapper" }
const _hoisted_3 = { class: "gfu-project-flip-card__stamp _gap-2" }
const _hoisted_4 = { class: "gfu-project-flip-card__stamp--right _gap-2 _z-1" }
const _hoisted_5 = { class: "gfu-project-card__body" }
const _hoisted_6 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _mb-1 _mt-3 _flex _ai-c _gap-1" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "gfu-bt gfu-bt--caption _tc--lighter _mt-1 _mb-3" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = { class: "_pa-3" }
const _hoisted_11 = {
  class: "gfu-hd gfu-project-card__title",
  "data-qa": "project-card:ProjectName"
}
const _hoisted_12 = {
  class: "_my-2",
  "data-qa": "project-Card:ShortDescription"
}
const _hoisted_13 = {
  key: 0,
  class: "_flex _jc-se _mt-6",
  "data-qa": "project-card:GameProperties"
}
const _hoisted_14 = ["data-qa"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _ttu _tac _mt-3" }
const _hoisted_17 = { class: "_mx-0 _my-1 _tac" }
const _hoisted_18 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _ttu _tac _mt-3" }
const _hoisted_19 = {
  key: 0,
  class: "_mx-0 _my-1 _tac"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _ttu _tac _mt-3" }
const _hoisted_22 = { class: "_mx-0 _my-1 _tac" }
const _hoisted_23 = {
  key: 3,
  class: "_tac _mt-3"
}
const _hoisted_24 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _ttu" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "_fw-eb _toe" }
const _hoisted_27 = {
  key: 4,
  class: "_tac _mt-3"
}
const _hoisted_28 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _ttu" }
const _hoisted_29 = { class: "_flexwrap _jc-c _gap-2 _my-1" }
const _hoisted_30 = ["href", "data-qa"]
const _hoisted_31 = { class: "_fw-eb _toe" }
const _hoisted_32 = ["aria-label"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_image = _resolveComponent("base-image")
  const _component_external_link = _resolveComponent("external-link")
  const _component_project_card_follow = _resolveComponent("project-card-follow")
  const _component_base_countdown_circle_timer = _resolveComponent("base-countdown-circle-timer")
  const _component_balloon_actions = _resolveComponent("balloon-actions")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_time_left = _resolveComponent("time-left")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_creators_line = _resolveComponent("creators-line")
  const _component_project_card_last_update = _resolveComponent("project-card-last-update")
  const _component_progress_bar = _resolveComponent("progress-bar")
  const _component_base_card = _resolveComponent("base-card")
  const _component_base_tag = _resolveComponent("base-tag")
  const _component_project_card_badge = _resolveComponent("project-card-badge")
  const _component_flip_card = _resolveComponent("flip-card")

  return (_openBlock(), _createBlock(_component_flip_card, {
    ref: "card",
    "is-flipped": _ctx.showDetails
  }, {
    face: _withCtx(() => [
      _createVNode(_component_base_card, {
        style: _normalizeStyle({ 'visibility': $options.isFaceVisible }),
        class: _normalizeClass($options.projectCardClasses),
        orientation: $props.orientation,
        "media-size": $props.mediaSize,
        scheme: $props.scheme,
        theme: $props.theme,
        "data-qa": `project-card-ID:${$props.projectID}`
      }, _createSlots({
        media: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createCommentVNode(" Since project can be external (eg. igg -> gf), we need to use base link "),
              _createVNode(_component_external_link, {
                class: "gfu-embed gfu-embed--1x1 _pos-r",
                href: $props.url,
                title: $props.name
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_image, {
                    src: $props.imageUrl,
                    alt: $props.name,
                    class: "gfu-embed__item",
                    style: _normalizeStyle($options.mask),
                    loading: "lazy"
                  }, null, 8 /* PROPS */, ["src", "alt", "style"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["href", "title"]),
              _createElementVNode("div", _hoisted_3, [
                ($options.isFollowControlsVisible)
                  ? (_openBlock(), _createBlock(_component_external_link, {
                      key: 0,
                      class: "gfu-link--nofx",
                      href: $props.url,
                      title: $props.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_project_card_follow, {
                          "project-id": $props.projectID,
                          "project-url": $props.relativeUrl,
                          "project-name": $props.name,
                          "follower-count": $props.followerCount,
                          "disable-follow": $options.isExternalProject
                        }, null, 8 /* PROPS */, ["project-id", "project-url", "project-name", "follower-count", "disable-follow"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["href", "title"]))
                  : _createCommentVNode("v-if", true),
                ($options.isBackersCountVisible)
                  ? (_openBlock(), _createBlock(_component_external_link, {
                      key: 1,
                      class: "gfu-link--nofx",
                      href: $props.url,
                      title: $props.name
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(['gfu-project-card-stamp gfu-project-card-follow _px-2', $options.backerLabelClass]),
                          "data-qa": "project-card:BackersCount"
                        }, [
                          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "_ga _ga--user-solid-icon _mr-1" }, null, -1 /* CACHED */)),
                          _createTextVNode(_toDisplayString($options.backersCountLabelFormatted), 1 /* TEXT */)
                        ], 2 /* CLASS */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["href", "title"]))
                  : _createCommentVNode("v-if", true)
              ]),
              ($options.isCountdownCircleTimerVisible)
                ? (_openBlock(), _createBlock(_component_base_countdown_circle_timer, {
                    key: 0,
                    timestamp: $options.countdownCircleTimerModel,
                    class: "_pos-a--cntr",
                    onCountdownFinished: $options.onCountdownFinished,
                    "data-qa": "project-card:CountdownCircle"
                  }, null, 8 /* PROPS */, ["timestamp", "onCountdownFinished"]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              ($options.hasActions)
                ? (_openBlock(), _createBlock(_component_balloon_actions, {
                    key: 0,
                    actions: $props.actions,
                    mode: $options.balloonActionsMode,
                    "balloon-style-props": $options.balloonStyleProps,
                    theme: "secondaryAlt",
                    "data-qa": "project-card:Actions"
                  }, null, 8 /* PROPS */, ["actions", "mode", "balloon-style-props"]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              ($options.isExternalProject)
                ? (_openBlock(), _createBlock(_component_base_image, {
                    key: 0,
                    src: $options.externalPlatformIcon,
                    width: "12",
                    height: "12"
                  }, null, 8 /* PROPS */, ["src"]))
                : _createCommentVNode("v-if", true),
              ($options.isExpressCrowdfunding)
                ? (_openBlock(), _createBlock(_component_base_icon, {
                    key: 1,
                    "icon-namespace": "ga",
                    name: "bolt-solid-icon",
                    class: "_tc--accent",
                    "data-qa": "project-card:ExpressCrowdfundingIcon"
                  }))
                : _createCommentVNode("v-if", true),
              _createElementVNode("strong", {
                class: _normalizeClass(['_ttu', $options.currentProjectInfo.projectPhaseTitleClass, '_toe']),
                "data-qa": "project-card:ProjectPhaseLabel"
              }, _toDisplayString($options.currentProjectInfo.projectPhaseLabel), 3 /* TEXT, CLASS */),
              ($options.isTimeLeftVisible)
                ? (_openBlock(), _createBlock(_component_time_left, _mergeProps({ key: 2 }, $options.timeLeft, {
                    class: "_whs-nw _tc--accent _ttl",
                    "data-qa": "project-card:TimeLeft"
                  }), null, 16 /* FULL_PROPS */))
                : _createCommentVNode("v-if", true),
              ($options.isPledgeManagerLimited)
                ? (_openBlock(), _createBlock(_component_tooltip, { key: 3 }, {
                    content: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.pledgeManagerLimitedTooltip), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_base_icon, { name: "circle-info" })
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("h3", {
              class: "gfu-hd gfu-project-card__title _line-clamp _line-clamp-2",
              title: $props.name,
              "data-qa": "project-card:ProjectName"
            }, [
              _createVNode(_component_external_link, { href: $props.url }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["href"])
            ], 8 /* PROPS */, _hoisted_7),
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_creators_line, {
                creator: $setup.mappedCreator,
                "co-creators": $setup.mappedCoCreators
              }, null, 8 /* PROPS */, ["creator", "co-creators"])
            ]),
            ($options.isProjectCanceled)
              ? (_openBlock(), _createBlock(_component_project_card_last_update, {
                  key: 0,
                  title: $props.lastUpdateTitle
                }, null, 8 /* PROPS */, ["title"]))
              : (_openBlock(), _createBlock(_resolveDynamicComponent($options.currentProjectInfo.summaryComponent), _normalizeProps(_mergeProps({ key: 1 }, $options.currentProjectInfo.props)), null, 16 /* FULL_PROPS */)),
            _createVNode(_component_progress_bar, {
              class: "gfu-project-card__progress-bar",
              value: $options.currentProjectInfo.fundsGathered,
              max: $options.currentProjectInfo.fundsRequired,
              "can-go-over": true,
              "progression-over-class": "gfu-progress-bar__progression-over gfu-progress-bar__progression-over--animated",
              "container-class": $options.currentProjectInfo.progressBarContainerClass,
              "progression-class": "gfu-progress-bar__progression--accent gfu-progress-bar--animated"
            }, null, 8 /* PROPS */, ["value", "max", "container-class"]),
            _createElementVNode("button", {
              class: "gfu-project-card__action-button",
              "aria-label": _ctx.Resources.Homepage.ProjectCardToggleDetailsLabel,
              tabindex: "-1",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleDetails && $options.toggleDetails(...args)))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", {
                class: "_ga _ga--revert _pa-1",
                tabindex: "0",
                "data-qa": "project-card:ReverseButton"
              }, null, -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_9)
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, [
        ($props.showLabels)
          ? {
              name: "labels",
              fn: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.labels, (label) => {
                  return (_openBlock(), _createBlock(_component_base_badge, {
                    key: label.name,
                    class: "_mr-1 _my-1",
                    theme: label.theme,
                    "data-qa": "project-card:BadgeText"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(label.name), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              key: "0"
            }
          : undefined
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["style", "class", "orientation", "media-size", "scheme", "theme", "data-qa"])
    ]),
    reverse: _withCtx(() => [
      (_ctx.showDetails)
        ? (_openBlock(), _createBlock(_component_base_card, {
            key: 0,
            class: _normalizeClass($options.projectCardClasses),
            orientation: $props.orientation,
            "media-size": $props.mediaSize,
            scheme: $props.scheme,
            "is-scrollable": _ctx.showDetails,
            theme: $props.theme,
            "data-qa": `project-card-ID:${$props.projectID}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h4", _hoisted_11, [
                  _createVNode(_component_external_link, { href: $props.url }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["href"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_external_link, { href: $props.url }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($props.shortDescription), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["href"])
                ]),
                ($options.areBoardGamePropertiesVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.boardgameProperties, (prop) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: prop.name,
                          class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _ttu _flex-basis-33 _tac"
                        }, [
                          _createTextVNode(_toDisplayString(prop.name) + " ", 1 /* TEXT */),
                          _createElementVNode("div", {
                            class: "gfu-hd gfu-hd--h4",
                            "data-qa": `project-card:${prop.dataQa}`
                          }, _toDisplayString(prop.value), 9 /* TEXT, PROPS */, _hoisted_14)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                (!!$props.catalogCategory)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.Resources.ProjectHome.ProjectPropertiesCategoryLabel), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(), _createBlock(_component_base_tag, {
                          key: $props.catalogCategory.name,
                          theme: "accent",
                          tag: "a",
                          href: $props.catalogCategory.url,
                          class: "_mr-1",
                          "data-qa": `project-category:${$props.catalogCategory.projectCategory}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($props.catalogCategory.name), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["href", "data-qa"]))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.Resources.ProjectHome.ProjectPropertiesTagsLabel), 1 /* TEXT */),
                  ($props.showTags && $options.tags.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
                          return (_openBlock(), _createBlock(_component_base_tag, {
                            key: tag.name,
                            tag: "a",
                            href: tag.url,
                            class: "_mr-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.name), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                ($options.displayProjectCardBadges.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.Resources.Homepage.ProjectCardBenefitsPropertyLabel), 1 /* TEXT */),
                      _createElementVNode("ul", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.displayProjectCardBadges, (badge) => {
                          return (_openBlock(), _createBlock(_component_project_card_badge, {
                            key: badge.text,
                            "tooltip-text": badge.tooltipText,
                            icon: badge.icon,
                            "data-qa": `project-card-benefit:${badge.name}`
                          }, null, 8 /* PROPS */, ["tooltip-text", "icon", "data-qa"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.mappedCreator.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.Resources.ProjectHome.ProjectStoryCreatorLabel), 1 /* TEXT */),
                      _createElementVNode("a", {
                        href: $setup.mappedCreator.url,
                        class: "_flex _ai-c _gap-1 _mt-1 _jc-c gfu-link gfu-link--nofx",
                        "data-qa": "creator-name"
                      }, [
                        ($setup.mappedCreator.avatarUrl)
                          ? (_openBlock(), _createBlock(_component_base_image, {
                              key: 0,
                              src: $setup.mappedCreator.avatarUrl,
                              alt: $setup.mappedCreator.name,
                              width: "30",
                              height: "30",
                              class: "_rounded--common _bxsh--base",
                              loading: "lazy"
                            }, null, 8 /* PROPS */, ["src", "alt"]))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("span", _hoisted_26, _toDisplayString($setup.mappedCreator.name), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_25)
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.hasCoCreators)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString($options.coCreatorsSectionLabel), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mappedCoCreators, (coCreator) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: coCreator.url,
                            href: coCreator.url,
                            class: "_flex _ai-c _gap-1 gfu-link gfu-link--nofx _max-w-100",
                            "data-qa": `co-creator-name:${coCreator.name}`
                          }, [
                            (coCreator.avatarUrl)
                              ? (_openBlock(), _createBlock(_component_base_image, {
                                  key: 0,
                                  src: coCreator.avatarUrl,
                                  alt: coCreator.name,
                                  width: "30",
                                  height: "30",
                                  class: "_rounded--common _bxsh--base",
                                  loading: "lazy"
                                }, null, 8 /* PROPS */, ["src", "alt"]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("span", _hoisted_31, _toDisplayString(coCreator.name), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_30))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  class: "gfu-project-card__action-button",
                  "aria-label": _ctx.Resources.Homepage.ProjectCardToggleDetailsLabel,
                  tabindex: "-1",
                  onClick: _cache[1] || (_cache[1] = (...args) => ($options.toggleDetails && $options.toggleDetails(...args)))
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("span", {
                    class: "_ga _ga--revert _pa-1",
                    tabindex: "0",
                    "data-qa": "project-card:FlipButton"
                  }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_32)
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["class", "orientation", "media-size", "scheme", "is-scrollable", "theme", "data-qa"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-flipped"]))
}